import { NameIcon } from '../../../icons/Name.icon';
import { Tooltip, message } from 'antd';
import { ConditionIcon, CopiesIcon, DobIcon, PhoneIcon } from '../../../icons';

const SchedulePageHeader = ({ getUuid }) => {
  const isMobile = window.innerWidth < 1260;

  return (
    <div
      className={`${
        isMobile ? '' : 'flex'
      } bg-white rounded-xl shadow-md px-1 py-1.5`}
    >
      <div className="text-[#000] text-lg font-semibold mb-1 mx-3 mr-4 items-center flex xl:hidden 2xl:flex min-w-fit">
        Patient details{' '}
      </div>
      <div
        className={
          isMobile
            ? ''
            : 'flex lg:justify-between items-center p-1 lg:p-1 mt-1 flex-wrap xs:mt-0 xs:gap-3 w-full'
        }
      >
        <div className={isMobile ? 'flex pt-1' : 'flex'}>
          <div className="circle-background lg:ml-1">
            <NameIcon
              className="patientname"
              name={
                getUuid?.patient_details?.first_name &&
                getUuid?.patient_details?.last_name
                  ? `${getUuid.patient_details.first_name} ${getUuid.patient_details.last_name}`
                  : 'N/A'
              }
            />
          </div>
          <Tooltip
            title={
              <span
                onClick={(e) => {
                  // Copy the tooltip text to the clipboard
                  navigator.clipboard.writeText(
                    `${getUuid?.patient_details?.patient_id}`
                  );
                  e.stopPropagation(); // Prevents triggering any other actions
                  message.success('Patient ID copied!', 1); // 1 second duration
                }}
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                {getUuid?.patient_details?.patient_id
                  ? `Patient ID: ${getUuid?.patient_details?.patient_id}`
                  : 'Patient ID: N/A'}
                <CopiesIcon height="15" width="15" color="#000" />
              </span>
            }
            placement="top"
          >
            <div
              className="mt-1 text-[#000] font-medium flex items-center ml-2"
              onClick={(e) => {
                navigator.clipboard.writeText(
                  `Patient ID: ${getUuid?.patient_details?.patient_id}`
                );
                e.stopPropagation();
              }}
            >
              {getUuid?.patient_details?.first_name &&
              getUuid?.patient_details?.last_name
                ? `${getUuid.patient_details.first_name} ${getUuid.patient_details.last_name}`
                : 'N/A'}
            </div>
          </Tooltip>
        </div>

        <div
          className={
            isMobile
              ? 'flex pt-2 gap-1 pl-3'
              : 'flex gap-1 items-center text-[#7F7F7F] '
          }
        >
          <DobIcon />
          <div className=" text-black font-sm">Date of birth :</div>
          {getUuid?.patient_details?.birth_date
            ? getUuid?.patient_details?.birth_date
            : 'N/A'}
        </div>

        <div
          className={
            isMobile
              ? 'flex pt-2 gap-1 pl-3'
              : 'flex gap-1 items-center text-[#7F7F7F] '
          }
        >
          <ConditionIcon />
          <div className=" text-black font-sm">Condition:</div>
          {getUuid?.appointment_details?.condition_name
            ? getUuid?.appointment_details?.condition_name == 'Unknown'
              ? 'Not Available'
              : getUuid?.appointment_details?.condition_name
            : getUuid?.condition_name
              ? getUuid?.condition_name == 'Unknown'
                ? 'Not Available'
                : getUuid?.condition_name
              : 'N/A'}
        </div>

        <div
          className={
            isMobile
              ? 'flex pt-2 gap-1 pl-3'
              : 'flex gap-1 items-center lg: mr-2 text-[#7F7F7F]'
          }
        >
          <PhoneIcon />
          <div className=" text-black font-sm">Phone :</div>
          {getUuid?.patient_details?.phone_id
            ? getUuid?.patient_details?.phone_id
            : 'N/A'}
        </div>
      </div>
    </div>
  );
};

export default SchedulePageHeader;
